<template>
  <tbody v-if="bill" class="tbody">
    <tr style="height: 50px">
      <td>
        {{ bill.billNo }}
      </td>
      <td>
        {{ getShortTitle(bill.title) }}
      </td>
      <td>
        {{ bill.orderNo }}
      </td>
      <td>
        {{ formatDate(bill.billDate) }}
      </td>
      <td>
        {{ formatDate(bill.dueDate) }}
      </td>
      <td>
        {{ bill.vendorName ? bill.vendorName : "Other" }}
      </td>
      <td>{{ bill.fare.currency }} {{ bill.fare.total }}</td>
      <td>
        <v-btn x-small color="grey" v-if="bill.status == 0">{{
          bill.statusStr
        }}</v-btn>
        <v-btn x-small color="cyan" v-if="bill.status == 1">{{
          bill.statusStr
        }}</v-btn>
        <v-btn x-small color="green" v-if="bill.status == 2">{{
          bill.statusStr
        }}</v-btn>
      </td>
      <td>
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Bill ?')"
          @click="deleteBill(bill._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          :to="'/bill/' + bill._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "BillRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
    _filterFor: {
      default: null,
    },
  },
})
export default class BillRow extends Vue {
  bill = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  getShortTitle(str) {
    return str ? (str.length > 15 ? str.substring(1, 15) + "..." : str) : "";
  }

  async deleteBill(bill_id) {
    common.setLoading(true);
    try {
      await doGet("/api/bill/" + bill_id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.bill = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.bill = val;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>